export const getNodeIdFromHandle = (handle: string) => {
	return handle?.split('-').pop();
};
